import { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';
import st from "./Skeleton.module.scss";

interface ISkeletonProps extends HTMLAttributes<HTMLDivElement> {
	/** Отображать анимацию загрузки */
	isLoading?: boolean;
	/** Сообщение об ошибке */
	errorMessage?: string;
};

/** Компонента-контейнер для отображения блока с анимацией загрузки */
const Skeleton = forwardRef<HTMLDivElement,ISkeletonProps>( ( { isLoading, errorMessage, children, className, ...otherProps }, ref ) => (
	<div ref={ref} className={classNames( className, { [st.skeleton]: isLoading } )} {...otherProps}>
		{ !errorMessage ? children : errorMessage }
	</div>
) );

export default Skeleton;
